import * as Yup from 'yup';

// eslint-disable-next-line import/prefer-default-export
export const logicValidationSchema = Yup.object({
  logic: Yup.array().of(Yup.object({
    id: Yup.string().trim().ensure().min(1, 'Required'),
  })),
});
